import type { Coach } from '../../api/client'
import type { GoalNumbers } from '../../plan/forecast'
import type { FreedomCard } from '../../types/app'
import FreedomLine from './FreedomLine'
import { MonthSection } from './PlanResult'

interface Props {
  freedom: FreedomCard | null
  goal: GoalNumbers
  coach: Coach | null
  coachFailed: boolean
  onRetryCoach: () => void
  editing: boolean
  now: Date
}

// hasThisWeek says whether there's anything that changes week to week: a
// Freedom Score, or a month measured against a live diary. Until then Goals
// is set-up only, and this card stays away.
export function hasThisWeek(freedom: FreedomCard | null, coach: Coach | null): boolean {
  const scored = !!freedom && freedom.enough && !freedom.waiting
  return scored || !!(coach?.started && coach.progress)
}

// ThisWeekCard is the weekly check-in, under the goal once there's anything
// to check: the Freedom Score, then this month so far and the coach.
export default function ThisWeekCard({ freedom, goal, coach, coachFailed, onRetryCoach, editing, now }: Props) {
  return (
    <section className="goals-card this-week" aria-labelledby="this-week-title">
      <h2 className="goals-card-title" id="this-week-title">
        This week
      </h2>
      <FreedomLine freedom={freedom} bare />
      <MonthSection goal={goal} coach={coach} coachFailed={coachFailed} onRetryCoach={onRetryCoach} editing={editing} now={now} />
    </section>
  )
}
